/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type AppAuditRunCompletedEventType =
  (typeof AppAuditRunCompletedEventType)[keyof typeof AppAuditRunCompletedEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppAuditRunCompletedEventType = {
  "run-completed": "run-completed",
} as const;
